var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sw-grid-flex sw-grid-flex--dir-column admin-material-table"
    },
    [
      _c("b-table", {
        attrs: {
          striped: "",
          hover: "",
          items: _vm.guidelines,
          fields: _vm.headers
        },
        scopedSlots: _vm._u(
          [
            {
              key: "cell(select)",
              fn: function(data) {
                return [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedGuideline,
                        expression: "selectedGuideline"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      id: "check-" + data.index,
                      disabled: _vm.showAddNewGuideline
                    },
                    domProps: {
                      value: data.item.id,
                      checked: _vm._q(_vm.selectedGuideline, data.item.id)
                    },
                    on: {
                      change: function($event) {
                        _vm.selectedGuideline = data.item.id
                      }
                    }
                  })
                ]
              }
            },
            _vm.showAddNewGuideline
              ? {
                  key: "custom-foot",
                  fn: function() {
                    return [
                      _c(
                        "b-tr",
                        [
                          _c("b-td"),
                          _vm._v(" "),
                          _c("b-td"),
                          _vm._v(" "),
                          _vm._l(_vm.newGuideline.fields, function(field) {
                            return _c("b-td", { key: field.name }, [
                              field.type === "select"
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: field.value,
                                          expression: "field.value"
                                        }
                                      ],
                                      staticClass:
                                        "sw-select--not-round sw--width-full",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            field,
                                            "value",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: true } },
                                        [_vm._v("Yes")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: false } },
                                        [_vm._v("No")]
                                      )
                                    ]
                                  )
                                : field.type === "textarea"
                                ? _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: field.value,
                                        expression: "field.value"
                                      }
                                    ],
                                    staticClass: "sw--width-full",
                                    domProps: { value: field.value },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          field,
                                          "value",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value: field.value,
                                        expression: "field.value",
                                        modifiers: { number: true }
                                      }
                                    ],
                                    staticClass:
                                      "sw--input-height__medium sw--font-size-14 sw--width-full",
                                    domProps: { value: field.value },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          field,
                                          "value",
                                          _vm._n($event.target.value)
                                        )
                                      },
                                      blur: function($event) {
                                        return _vm.$forceUpdate()
                                      }
                                    }
                                  })
                            ])
                          }),
                          _vm._v(" "),
                          _c("b-td")
                        ],
                        2
                      )
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c("bottom-banner", {
        attrs: {
          "missing-info": !_vm.materialId ? ["Basic Information"] : [],
          "show-saved-message": _vm.showSavedMessage,
          "show-cancel-btn": _vm.showCancelBtn,
          "show-add-new-btn": _vm.showAddNewBtn
        },
        on: {
          saved: _vm.saveGuideline,
          "add-new": _vm.showAddNew,
          cancel: _vm.cancelAddingNew
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }